import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function getAdminUserreducer(state = initialState.adminUser, action) {
	switch (action.type) {
		case types.GET_ADMIN_USER: {
			return action.response;
		}
		case types.CLEAR_ADMIN_USER: {
			return initialState.adminUser;
		}
		default:
			return state;
	}
}
